import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-tours-skeleton',
  templateUrl: environment.mobile ? './tours-skeleton.component.mobile.html' : './tours-skeleton.component.html',
  styleUrls: environment.mobile ? ['./tours-skeleton.component.mobile.scss'] : ['./tours-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ToursSkeletonComponent {
  readonly skeletonCards = Array.from({ length: 3 }, (_, index) => index);
}
